import actions from '@/requests/workspaces/constants';
import withDraft from '@/utils/draftHelper';
import { showWorkflowState } from './state';

const showWorkspaceFormForRequest = withDraft((draft, action) => (
  showWorkflowState(draft, { ...action, result: action.workflow })));

export default {
  [actions.SHOW_WORKSPACE_FORM_FOR_REQUEST]: showWorkspaceFormForRequest,
};
